import React from "react";
import _ from "lodash";
import "./style.css";
import CrossingHeading from "./header";
import CrossingBody from "./bodyv2";
import { getFieldsReportForm } from "../../appFormReportsUtility";
import { checkInspected } from "../../../Timps/YardTrackInspection/YardTrackDefectReport";
import { CNSiteForms } from "../CombinedForms";

class CrossingTestsInspections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basicData: {},
      reportData: {},
      tests: {},
    };
  }

  componentDidMount() {
    this.caclulateData(this.props.gradeCrossingData);
  }
  caclulateData(gradeCrossingTests) {
    let tests = {
      FlashingLight: { condition: "", comments: "" },
      GateArms: { condition: "", comments: "" },
      WarningSystemOperation: { condition: "", comments: "" },
      Grounds: [],
      StandByPower: { condition: "", comments: "" },
      CNMonthlyTests: [],
      CNQuarterlyTests: [],
      CNAnnualPlusTests: [],
      TrafficPreEmption: [],
      CutOutCircut: [],
      InsulJtsBonds: { condition: "", comments: "" },
      LampVoltages: { condition: "", comments: "" },
      LightAlignment: { condition: "", comments: "" },
      HoldClearDevice: { condition: "", comments: "" },
      WarningTimeTests: [],
      FlasherTestResults: { condition: "", comments: "", flashesPerMinute: "", flashNomen: "" },
      FlasherTestArrayResults: [],
      TimingRelayDevice: [],
      BatteryCards: [],
    };

    let primaryBatteryMonthlyReports = [];
    let primaryBatteryQuarterlyReports = [];
    let secondaryBatteryMonthlyReports = [];
    let secondaryBatteryQuarterlyReports = [];

    gradeCrossingTests &&
      gradeCrossingTests.forEach((testSched) => {
        if ("CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251" === testSched.testCode) {
          primaryBatteryMonthlyReports.push(testSched);
        } else if ("CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251" === testSched.testCode) {
          primaryBatteryQuarterlyReports.push(testSched);
        } else if ("CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251" === testSched.testCode) {
          secondaryBatteryMonthlyReports.push(testSched);
        } else if ("CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251" === testSched.testCode) {
          secondaryBatteryQuarterlyReports.push(testSched);
        }
        if (testSched) this.setTestsData(testSched, tests);
      });
    // console.log(tests);
    this.props.batteryCardsOnly &&
      (tests["BatteryCards"] = [
        { name: "Primary Batteries Monthly", freq: "", value: primaryBatteryMonthlyReports },
        { name: "Primary Batteries Quarterly", freq: "", value: primaryBatteryQuarterlyReports },
        { name: "Secondary Batteries Monthly", freq: "", value: secondaryBatteryMonthlyReports },
        { name: "Secondary Batteries Quarterly", freq: "", value: secondaryBatteryQuarterlyReports },
      ]);
    this.setState({
      tests: tests,
    });
  }
  setTestsData(testSched, tests) {
    this.arrayMethods = {
      FRA234_249: "Grounds",
      FRA234_269: "CutOutCircut",
      FRA234_261: "TrafficPreEmption",
      FRA234_259: "WarningTimeTests",
      FRA234_265: "TimingRelayDevice",
      CN_Monthly_PreemptionAndAAWS_FRA234_261: "PreemptionAaws",
      CN_Annual_TimingDevices_FRA234_265: "TimingRelayDevice",
      CN_Quarterly_CutoutCircuits_FRA234_269: "CutOutCircut",
      CN_Annual_WarningTime_FRA234_259: "WarningTimeTests",
      FRA234_253A: "FlasherTestArrayResults",
      
    };

    this.arrayAndObjectMethods={
      FRA234_251: "StandByPower",
      FRA234_253M:"FlashingLight",
      FRA234_255: "GateArms",
    }

    this.objectMethods = {
      // CN Site Monthly Tests
      CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: "CNMonthlyTests",
      CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251: "CNMonthlyTests",
      CN_Monthly_PrimaryApproachCircuits: "CNMonthlyTests",
      CN_Monthly_ACAndDCMode: "CNMonthlyTests",
      CN_Monthly_Bell_FRA234_257: "CNMonthlyTests",
      CN_Monthly_ACVoltage: "CNMonthlyTests",
      CN_Monthly_CWMSDevices: "CNMonthlyTests",
      CN_Monthly_GeneratorAtsTest: "CNMonthlyTests",
      CN_Monthly_LightUnitsAndSigns_FRA234_253: "CNMonthlyTests",
      CN_Monthly_GateArmsAndMechanism_FRA234_255ab: "CNMonthlyTests",
      CN_Monthly_ControllingDevices_FRA234_257ab: "CNMonthlyTests",
      CN_Monthly_PreemptionAndAAWS_FRA234_261: "CNMonthlyTests",

      // CN Site Quarterly Tests
      CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251: "CNQuarterlyTests",
      CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251: "CNQuarterlyTests",
      CN_Quarterly_GeneratorInspection: "CNQuarterlyTests",
      CN_Quarterly_InsulatedJointsAndTrackConnections_FRA234_271: "CNQuarterlyTests",

      // CN Site Annual+ Tests
      CN_Annual_ConditionOfPlans_FRA234_201And236_1: "CNAnnualPlusTests",
      CN_Annual_CableHousing: "CNAnnualPlusTests",
      CN_Annual_GateArmsAndMechanism_FRA234_255: "CNAnnualPlusTests",
      CN_Annual_BatteryLoad: "CNAnnualPlusTests",
      CN_Annual_PrimaryBatteryExhuastion: "CNAnnualPlusTests",
      CN_Annual_GeneracGeneratorInspection: "CNAnnualPlusTests",
      CN_Annual_GeneratorInspection: "CNAnnualPlusTests",
      CN_2Year_GeneratorInspection: "CNAnnualPlusTests",
      CN_Annual_LampVoltageFRA234_253: "CNAnnualPlusTests",
      CN_Annual_LightUnitAlignmentFRA234_253: "CNAnnualPlusTests",
      CN_Annual_ApproachesWithCWMS: "CNAnnualPlusTests",

      CN_Annual_FlashRate_FRA234_253: "FlasherTestResults",

      
    
      FRA234_257: "WarningSystemOperation",
      FRA234_271: "InsulJtsBonds",
      FRA234_253_LV: "LampVoltages",
      FRA234_253_LA: "LightAlignment",
      FRA234_255c: "HoldClearDevice",
      FRA234_253A: "FlasherTestResults",
    };

    let arrayTest = this.arrayMethods[testSched.testCode];
    if (arrayTest) {
      tests[arrayTest] = this.arrayMethod(testSched, tests[arrayTest]);
    } 
    else if(this.objectMethods[testSched.testCode]){
    
      let objectTest = this.objectMethods[testSched.testCode];
      if (objectTest) {
        let cnSiteForm =
          ["CNMonthlyTests", "CNQuarterlyTests", "CNAnnualPlusTests"].includes(objectTest) &&
          CNSiteForms.find((form) => form.code === testSched.testCode);
        const _title = cnSiteForm ? cnSiteForm.description : null;
        this.objectMethod(testSched, tests[objectTest], _title);
      }
    }

    else if(this.arrayAndObjectMethods[testSched.testCode]){
      let arrayAndObjectTest = this.arrayAndObjectMethods[testSched.testCode];
      let test = this.arrayMethod(testSched, tests[arrayAndObjectTest]);

      if(test.length!==0){
        console.log("In tabel",arrayAndObjectTest)
        tests[arrayAndObjectTest]=test
      }
      else{
      
      if (arrayAndObjectTest) {
        console.log("In object",arrayAndObjectTest)
        let cnSiteForm =
          ["CNMonthlyTests", "CNQuarterlyTests", "CNAnnualPlusTests"].includes(arrayAndObjectTest) &&
          CNSiteForms.find((form) => form.code === testSched.testCode);
        const _title = cnSiteForm ? cnSiteForm.description : null;
        this.objectMethod(testSched, tests[arrayAndObjectTest], _title);
      }
    }
  }


  }

  objectMethod(testSched, testObjOrArray, title) {
    let testObj = null;
    if (Array.isArray(testObjOrArray)) {
      testObjOrArray.push({ condition: "", comments: "" });
      testObj = testObjOrArray[testObjOrArray.length - 1];
    } else {
      testObj = testObjOrArray;
    }
    let inspected = checkInspected(testSched.formData);
    let conditionField = testSched.formData && testSched.formData.find((field) => field && field.id === "test");
    let commentsField = testSched.formData && testSched.formData.find((field) => field && field.id === "com");
    if ((conditionField && conditionField.value) || (commentsField && commentsField.value)) testObj.visible = true;
    testObj.condition = conditionField && conditionField.value;
    testObj.comments = commentsField && commentsField.value;
    testObj.title = title;
    testObj.completion = inspected;
    if (["FRA234_253A", "CN_Annual_FlashRate_FRA234_253"].includes(testSched.testCode)) {
      let flasherField = testSched.formData && testSched.formData.find((field) => field && field.id === "desc");
      let flashperMinField = testSched.formData && testSched.formData.find((field) => field && field.id === "flash");
      testObj.flashNomen = flasherField && flasherField.value;
      testObj.flashesPerMinute = flashperMinField && flashperMinField.value;
    }
  }

  arrayMethod(testSched) {
    let data = [];
    let table = testSched && testSched.formData && testSched.formData.find((field) => field && field.type === "table");
    if (table && table.value) {
      data = getFieldsReportForm(table.value);
    }
    return data;
  }

  render() {
    return (
      <React.Fragment>
        <div className="mainContent table-report CrossingTestsInspections last-page-break-print" style={{ minHeight: "800px" }}>
          <CrossingHeading
            hideMasterKey={this.props.hideMasterKey}
            mainTitle="Test & Inspection Report"
            showStandBy={Array.isArray(this.state.tests.StandByPower) ? false : true}
            notes={this.props.hideCommonNote ? null : "True"}
            testType="Crossing"
            data={this.props.basicData}
            selectedAssetId={this.props.selectedAssetId}
          />
          <CrossingBody tests={this.state.tests} batteryCardsOnly={this.props.batteryCardsOnly} />
        </div>
      </React.Fragment>
    );
  }
}

export default CrossingTestsInspections;



// WEBPACK FOOTER //
// ./src/components/Reports/sims/FRA_Crossing/FRA_CrossingReport/crossingTestsInspections.jsx